<div class="asset-metadata-container h-full">
  <div class="header rounded-lg flex flex-row items-center sticky top-0 asset-details p-4 z-50">
    <h2 class="asset-details-title title text-xl font-bold" i18n>General Info</h2>
    <div class="actions text-right">
      <button *ngIf="editFlag" mat-icon-button class="save-button pl-4 cursor-pointer" role="button" [disabled]="updateAssetForm.invalid" i18n-matTooltip matTooltip="Save" (click)="saveAssetInfo()">
        <mat-icon class="material-icons-outlined">save</mat-icon>
      </button>
      <button *ngIf="editFlag" mat-icon-button class="pl-4 cursor-pointer" role="button" i18n-matTooltip matTooltip="Close" (click)="editInformation()">
        <mat-icon class="material-icons-outlined">close</mat-icon>
      </button>
      <button
        *ngIf="
          ![CustomClients.Standard, CustomClients.SEAT, CustomClients.VKB, CustomClients.LufthansaMediacenter, CustomClients.LufthansaMedialounge].includes(assetInfoObject.customerName) &&
          !editFlag &&
          (asset?.accessKeys ? (AccessAsset(asset) | can: 'update') : false)
        "
        mat-icon-button
        class="cursor-pointer"
        role="button"
        i18n-matTooltip
        matTooltip="Edit asset info"
        (click)="editInformation()"
      >
        <mat-icon class="material-icons-outlined">edit</mat-icon>
      </button>
    </div>
  </div>
  <div class="details px-4">
    <div
      class="detail-header"
      *ngIf="
        assetInfoObject?.customerName === CustomClients.Standard ||
        ((assetInfoObject?.customerName === CustomClients.LufthansaMediacenter || assetInfoObject?.customerName === CustomClients.LufthansaMedialounge) && editFlag)
      "
    >
      <ng-template ngFor let-assetObj [ngForOf]="assetInfoObject.metadata">
        <form class="asset-info-form" [formGroup]="updateAssetForm" *ngIf="editFlag && assetObj.editable">
          <div *ngIf="assetObj.formControlName === 'name'" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label field-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
            <mat-form-field appearance="outline" color="primary" class="dataset-entry-value w-3/5">
              <input type="text" placeholder="{{ assetObj.fieldLabel }}" matInput formControlName="name" />
            </mat-form-field>
          </div>
          <div class="dataset-entry my-2" *ngIf="assetObj.formControlName === 'description'" [ngClass]="'entry-' + assetObj.formControlName">
            <span class="dataset-entry-label field-label float-left">{{ assetObj.fieldLabel }}</span>
            <sp-editor
              formControlName="description"
              [placeholder]="assetObj.fieldLabel"
              [maxLength]="5000"
              [taggingOptions]="taggingOptions"
              (usersList)="taggedUserList($event)"
              (descriptionText)="editorDescriptionText($event)"
              class="dataset-entry-value"
            ></sp-editor>
          </div>
          <div *ngIf="['agency', 'client', 'brand', 'status'].includes(assetObj.formControlName)" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label field-label w-2/5">{{ assetObj.fieldLabel }}</span>
            <sp-mat-select-search
              class="dataset-entry-value w-3/5 inline-block"
              [formControlName]="assetObj.formControlName"
              [dataSource]="assetObj.options"
              [config]="{ search: true, required: true, titleCase: assetObj.formControlName === 'status', requiredText: assetObj.fieldLabel + ' ' + textIsRequired }"
              (selectedChange)="onAgencySelect($event, assetObj.formControlName)"
              [attrDataTestId]="'asset-metadata_select_' + assetObj.formControlName"
              class="dataset-entry-value"
            ></sp-mat-select-search>
          </div>
          <div *ngIf="assetObj.formControlName === 'jobNumber'" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label field-label w-2/5">{{ assetObj.fieldLabel }}</span>
            <mat-form-field appearance="outline" color="primary" class="dataset-entry-value w-full">
              <input type="text" placeholder="{{ assetObj.fieldLabel }}" matInput formControlName="jobNumber" pattern="[0-9\-]*" (keypress)="restrictInput($event)" />
            </mat-form-field>
          </div>
          <div *ngIf="assetObj.formControlName === 'plannedDeletion'" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
            <sp-date-picker
              formControlName="plannedDeletion"
              [dateCssClass]="'w-3/5'"
              [enableClearButton]="true"
              (selectedDate)="onDateSelection('plannedDeletion')"
              class="dataset-entry-value"
            ></sp-date-picker>
          </div>
          <div *ngIf="assetObj.formControlName === 'publishStartDate' && (AccessAsset(asset) | can: 'update.allstatus')" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
            <sp-date-picker
              formControlName="publishStartDate"
              [dateCssClass]="'w-3/5'"
              [enableClearButton]="true"
              (selectedDate)="onDateSelection('publishStartDate')"
              class="dataset-entry-value"
            ></sp-date-picker>
          </div>
          <div *ngIf="assetObj.formControlName === 'publishEndDate' && (AccessAsset(asset) | can: 'update.allstatus')" [ngClass]="'entry-' + assetObj.formControlName" class="dataset-entry">
            <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
            <sp-date-picker
              formControlName="publishEndDate"
              [dateCssClass]="'w-3/5'"
              [enableClearButton]="true"
              (selectedDate)="onDateSelection('publishEndDate')"
              class="dataset-entry-value"
            ></sp-date-picker>
          </div>
        </form>
        <ng-template [ngIf]="asset[assetObj.formControlName] || (asset.customFields && asset.customFields[assetObj.formControlName])">
          <div class="pb-1">
            <div *ngIf="!editFlag || !assetObj.editable">
              <div class="dataset-entry flex row items-start" *ngIf="['name', 'jobNumber'].includes(assetObj.formControlName)" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div
                  class="dataset-entry-value inline-block w-3/5 break-words"
                  [ngClass]="{
                    'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
                  }"
                >
                  <span class="mr-2">{{ asset[assetObj?.formControlName || ''] }}</span>
                </div>
              </div>
              <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'description' && asset['description']" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div
                  class="dataset-entry-value inline-block w-3/5 break-words"
                  [ngClass]="{
                    'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
                  }"
                >
                  <div class="ql-container ql-snow !min-h-[inherit] !bg-inherit !border-0">
                    <div class="ql-editor !p-0 !min-h-[inherit] !overflow-y-hidden" [innerHTML]="asset[assetObj?.formControlName || '']"></div>
                  </div>
                </div>
              </div>
              <div class="dataset-entry flex row items-start" *ngIf="['agency', 'client', 'brand'].includes(assetObj.formControlName)" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div
                  class="dataset-entry-value inline-block w-3/5 break-words"
                  [ngClass]="{
                    'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
                  }"
                >
                  <span>{{ asset[assetObj?.formControlName || '']?.name }}</span>
                </div>
              </div>
              <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'medium' && mediumFields.length > 0" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">Medium</span>
                <div class="dataset-entry-value inline-block w-3/5">
                  <span>{{ mediumFields.join(', ') }}</span>
                </div>
              </div>
              <div class="dataset-entry flex row items-start" *ngIf="assetObj.customValue" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div class="dataset-entry-value inline-block w-3/5" *ngIf="assetObj.fieldType === 'multiSelect'">
                  <span>{{ asset.customFields && asset.customFields[assetObj.formControlName].join(', ') }}</span>
                </div>
                <div class="dataset-entry-value inline-block w-3/5" *ngIf="assetObj.fieldType !== 'multiSelect'">
                  <span>{{ asset.customFields && asset.customFields[assetObj.formControlName] }}</span>
                </div>
              </div>
              <div
                class="dataset-entry flex row items-start"
                *ngIf="['createdBy', 'updatedBy'].includes(assetObj.formControlName) && asset[assetObj.formControlName]"
                [ngClass]="'entry-' + assetObj.formControlName"
              >
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div class="dataset-entry-value inline-block w-3/5">
                  <span class="cursor-pointer hover:bg-[#e3e0e0] -m-1 px-1 py-1 rounded-lg" (click)="assetCommonService.onClick(assetObj.formControlName, asset)">
                    {{ (valueListsService.lookupUserInfo(asset[assetObj.formControlName]) | async)?.name }}
                  </span>
                </div>
              </div>
              <div
                class="dataset-entry flex row items-center"
                *ngIf="['createdAt', 'updatedAt', 'publishStartDate', 'publishEndDate'].includes(assetObj.formControlName) && asset[assetObj.formControlName]"
                [ngClass]="'entry-' + assetObj.formControlName"
              >
                <span class="dataset-entry-label w-2/5 field-label">{{ assetObj.fieldLabel }}</span>
                <div
                  class="dataset-entry-value inline-block w-3/5"
                  [ngClass]="{
                    'border border-[rgba(0,0,0,.12)] rounded-lg p-2 mb-4 text-[rgba(0,0,0,.6)]': editFlag && !assetObj.editable,
                  }"
                >
                  <span *ngIf="asset[assetObj?.formControlName || '']; else noValue">{{ asset[assetObj?.formControlName || ''] | spDateFormat: { isSafe: true } }}</span>
                  <ng-template #noValue> </ng-template>
                </div>
              </div>
              <div class="dataset-entry flex row items-start" *ngIf="assetObj.formControlName === 'status' && asset['status']" [ngClass]="'entry-' + assetObj.formControlName">
                <span class="dataset-entry-label w-2/5 field-label">Status</span>
                <div class="dataset-entry-value inline-block w-3/5">
                  <span>{{ asset[assetObj?.formControlName || ''] | titlecase }}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-template>
    </div>
    <div class="detail-header" *ngIf="brandingKey === CustomClients.Arval">
      <thehubz-arval-asset-metadata
        #arvalAssetMetadata
        [assetInfoObject]="assetInfoObject"
        [editFlag]="editFlag"
        [asset]="asset"
        (taggedUser)="taggedUserList($event)"
        (descriptionText)="editorDescriptionText($event)"
      ></thehubz-arval-asset-metadata>
    </div>
    <div class="detail-header" *ngIf="brandingKey === CustomClients.Vorwerk">
      <thehubz-vorwerk-asset-metadata #vorwerkAssetMetadata [assetInfoObject]="assetInfoObject" [editFlag]="editFlag" [asset]="asset"></thehubz-vorwerk-asset-metadata>
    </div>
    <div class="detail-header" *ngIf="(brandingKey === CustomClients.LufthansaMediacenter || brandingKey === CustomClients.LufthansaMedialounge) && !editFlag">
      <thehubz-lufthansa-asset-metadata [assetInfoObject]="assetInfoObject" [asset]="asset"></thehubz-lufthansa-asset-metadata>
    </div>
    <div class="detail-header" *ngIf="brandingKey === CustomClients.VKB && !editFlag">
      <thehubz-vkb-asset-metadata [asset]="asset"></thehubz-vkb-asset-metadata>
    </div>
    <div class="detail-header" *ngIf="brandingKey === CustomClients.SEAT && !editFlag">
      <thehubz-seat-asset-metadata [asset]="asset"></thehubz-seat-asset-metadata>
    </div>
    <div *ngIf="brandingKey === CustomClients.WestLotto && asset.customFields">
      <thehubz-westlotto-metadata [asset]="asset"></thehubz-westlotto-metadata>
    </div>
  </div>
</div>
<thehubz-asset-notifications [asset]="asset"></thehubz-asset-notifications>
